export default __webpack_public_path__ + "static/media/movies.39602f3a.png";